<template>
  <div>
      <div class="security-row">
          <ActiveBrowserSession></ActiveBrowserSession>
          <IpRestriction></IpRestriction>
      </div>
      <AccessLogsTable></AccessLogsTable>
  </div>
</template>

<script>
import ActiveBrowserSession from "../../../../components/user/profileSettings/security/ActiveBrowserSession"
import IpRestriction from "../../../../components/user/profileSettings/security/IPRestriction"
import AccessLogsTable from "../../../../components/user/profileSettings/security/AccessLogsTable"
export default {
    components: {
        ActiveBrowserSession,
        IpRestriction,
        AccessLogsTable
    }
}
</script>

<style>
.security-row{
    display: flex;
    justify-content: space-between;
}

@media only screen and (max-width: 1250px){
    .active-browser-session-main, .ip-restriction-session-main{
        flex: 44% !important;
        width: 44% !important;
        max-width: 44% !important;
    }
}

@media only screen and (max-width: 600px){
    .security-row{
        flex-wrap: wrap !important;
    }
     .active-browser-session-main, .ip-restriction-session-main{
        flex: 100% !important;
        width: 100% !important;
        max-width: 100% !important;
        margin-bottom: 32px;
    }
}
</style>